import { expose } from 'comlink';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { AbstractWarehouseSyncStepWorker } from './abstract-warehouse-worker.utils';
import { WarehouseSyncStepTaskContext } from '../executors';
import type { ProgressCallback } from '../executors';
import { SyncedWarehouse } from '../../warehouse/warehouse.dto';
import { dtoConverter, WAREHOUSES_STORE, WW_WAREHOUSE_ISSUE_SEQUENCE, WW_WAREHOUSES_COLLECTION, logger } from '@damofire/data-commons';

export class WarehouseStepsWorker extends AbstractWarehouseSyncStepWorker {
  constructor() {
    super(WAREHOUSES_STORE, 'WAREHOUSE');
  }

  protected async download(ctx: WarehouseSyncStepTaskContext, onProgress?: ProgressCallback): Promise<void> {
    logger.debug('WarehouseStepsWorker::download', { division: ctx.division, category: 'sync' });

    const warehouseDoc = await getDoc(
      doc(getFirestore(), `${WW_WAREHOUSES_COLLECTION}/${ctx.division}`).withConverter(dtoConverter({ syncId: ctx.syncId, lastAccessedDate: new Date() })),
    );
    const syncedWarehouse = warehouseDoc.data() as SyncedWarehouse;

    // Set issueSequenceNumber in warehouse stats so we can access it in idb
    const issueSequence = await getDoc(doc(getFirestore(), `${WW_WAREHOUSES_COLLECTION}/${ctx.division}/${WW_WAREHOUSE_ISSUE_SEQUENCE}`));
    syncedWarehouse.statistics.issues.issueSequenceNumber = issueSequence.get('value') || 1;

    if (!this.shouldStopTask) {
      const tx = await this.idbService.createTransaction(this.store);
      await this.idbService.update(this.store, syncedWarehouse, tx);
      await tx.done;
      onProgress?.(100, { processed: 1, expected: 1 });
    }
  }
}

expose(WarehouseStepsWorker);
